<template>
	<ProgressSpinner v-if="!asset"/>

	<Container class="pt-6 w-full h-screen flex flex-col" v-if="asset">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">

			<Breadcrumb :home="home" :model="items" class="mb-3">
				<template #item="{ item, props }">
					<router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
						<a :href="href" v-bind="props.action" @click="navigate">
							<i :class="[item.icon, 'text-color']"/>
							<span class="text-surface-500 dark:text-surface-400 font-semibold">{{ item.label }}</span>
						</a>
					</router-link>

          <span v-else-if="item.action" @click="item.action" v-bind="props.action">
            <i :class="[item.icon, 'text-color']"/>
            <span class="text-surface-500 dark:text-surface-400 font-semibold">{{ item.label }}</span>
          </span>
        </template>
			</Breadcrumb>

			<PageHeading>{{ asset.name ?? $route.params.asset }}</PageHeading>
		</div>

		<div class="bg-surface-0 dark:bg-surface-800 z-40 -mx-8 px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<div class="flex-1 overflow-y-auto">
			<router-view
					@on-save="onSave"
					@on-delete="$emit('on-delete')"
					:asset="asset"
			></router-view>
		</div>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useAssetsStore } from "@/stores/assets.js";
import Container from "@/Components/Container.vue";


export default {
	name: "AssetView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			asset: undefined,
			params: {
				include: [
          'assetType',
					'company',
					'devices',
					'devices.deviceType',
					'devices.deviceModel',
					'devices.deviceRevision',
					'devices.currentFirmware',
					'rxSwins',
					'rxSwins.regulation',
					'rxSwins.mappings',
				].join(','),
			},
      home: {
        icon: 'ti ti-home text-lg',
        route: { name: 'home'}
      },
		}
	},
	watch: {
		'$route.params.asset': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.asset === 'NEW') {
						this.asset = {};
					} else {
						this.asset = await this.fetchAsset();
					}
				} else {
					this.asset = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useAssetsStore),
		tabs() {
			return [
				{
					label: this.$t('common.summary'),
					current: this.$route.name === 'assets.show',
					to: {name: 'assets.show', params: this.$route.params}
				},
				{
          label: this.$t('common.properties'),
					current: this.$route.name === 'assets.show.properties',
					to: {name: 'assets.show.properties', params: this.$route.params}
				},
				// {
				// 	label: 'Devices',
				// 	current: this.$route.name === 'assets.show.devices',
				// 	to: {name: 'assets.show.devices', params: this.$route.params}
				// },
				{
          label: this.$t('common.history'),
					current: this.$route.name === 'assets.show.history',
					to: {name: 'assets.show.history', params: this.$route.params}
				},
			]
		},
    items(){
      return [{
        icon: 'ti ti-arrow-back-up text-xl',
        label: 'Back',
        action: () => this.$router.back(),
      }];
    }
	},
	methods: {
		async onSave() {
			this.asset = await this.fetchAsset();
		},
		fetchAsset() {
			return this.assetsStore.showAsset(this.$route.params.asset, this.params);
		}
	},
}
</script>